import EmptyState from "../common/EmptyState";

const DataTable = ({
  columns = [],
  rows = [],
  rowKey = "id",
  loading = false,
  emptyTitle =
    "No records found",
  emptyMessage =
    "There is no data to display.",
  onRowClick = null,
}) => {
  if (loading) {
    return (
      <div className="app-table-loading">
        Loading...
      </div>
    );
  }

  if (
    !Array.isArray(rows) ||
    rows.length === 0
  ) {
    return (
      <EmptyState
        title={
          emptyTitle
        }
        message={
          emptyMessage
        }
      />
    );
  }

  return (
    <div className="app-data-table-wrapper">
      <table className="app-data-table">
        <thead>
          <tr>
            {columns.map(
              (column) => (
                <th
                  key={
                    column.key
                  }
                  className={
                    column.className ||
                    ""
                  }
                >
                  {
                    column.label
                  }
                </th>
              )
            )}
          </tr>
        </thead>

        <tbody>
          {rows.map(
            (
              row,
              rowIndex
            ) => {
              const key =
                typeof rowKey ===
                "function"
                  ? rowKey(
                      row,
                      rowIndex
                    )
                  : row[
                      rowKey
                    ] ??
                    rowIndex;

              return (
                <tr
                  key={key}
                  className={
                    onRowClick
                      ? "clickable"
                      : ""
                  }
                  onClick={() =>
                    onRowClick?.(
                      row
                    )
                  }
                >
                  {columns.map(
                    (
                      column
                    ) => (
                      <td
                        key={
                          column.key
                        }
                        className={
                          column
                            .cellClassName ||
                          ""
                        }
                      >
                        {column.render
                          ? column.render(
                              row,
                              rowIndex
                            )
                          : row[
                              column
                                .key
                            ]}
                      </td>
                    )
                  )}
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;